// Export generated banners as PNG images in the browser (no server rendering).
// Each banner is a self-contained, inline-styled <div data-banner-size="WxH">.
// It is drawn through an SVG <foreignObject> onto a canvas at 2x for crisp text.
// Images are inlined as data URIs first: a canvas can't load external images
// inside an SVG, and inlining keeps the canvas exportable.

async function toDataUri(url) {
  const res = await fetch(url, { credentials: 'include' });
  if (!res.ok) throw new Error(`Image ${res.status}`);
  const blob = await res.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

async function inlineImages(el) {
  for (const img of el.querySelectorAll('img')) {
    const src = img.getAttribute('src');
    if (!src || src.startsWith('data:')) continue;
    try {
      img.setAttribute('src', await toDataUri(src));
    } catch {
      img.remove(); // e.g. an external logo that blocks cross-origin requests
    }
  }
}

function renderToPng(el, width, height, scale = 2) {
  const xhtml = new XMLSerializer().serializeToString(el);
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}"><foreignObject x="0" y="0" width="${width}" height="${height}">${xhtml}</foreignObject></svg>`;
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = width * scale;
      canvas.height = height * scale;
      const ctx = canvas.getContext('2d');
      ctx.scale(scale, scale);
      ctx.drawImage(img, 0, 0, width, height);
      canvas.toBlob(blob => (blob ? resolve(blob) : reject(new Error('Could not create PNG'))), 'image/png');
    };
    img.onerror = () => reject(new Error('Could not render banner'));
    img.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
  });
}

function saveBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}

// Downloads one PNG per banner found at previewUrl. Returns the number exported.
export async function exportBannersAsPng(previewUrl, baseName = 'banner') {
  const res = await fetch(previewUrl, { credentials: 'include' });
  if (!res.ok) throw new Error('Could not load the banner');
  const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
  const banners = [...doc.querySelectorAll('[data-banner-size]')];
  if (!banners.length) throw new Error('No banners found in this asset. Regenerate it to enable PNG export.');

  let count = 0;
  for (const el of banners) {
    const [width, height] = el.getAttribute('data-banner-size').split('x').map(Number);
    if (!width || !height) continue;
    await inlineImages(el);
    const blob = await renderToPng(el, width, height);
    saveBlob(blob, `${baseName}-${width}x${height}.png`);
    count++;
    await new Promise(r => setTimeout(r, 350)); // let the browser handle each download
  }
  return count;
}
